import { useContext, useMemo } from 'react';
import { Button } from 'react-bootstrap';
import AuthContext from '../../../contexts/AuthContext';
import { UserIcon } from '../../../assets/Icon';
import useAPI from '../../../hooks/useAPI';
import { toast } from 'react-toastify';
import styles from './style.module.scss';

type Props = {
  onChange: (val?: string) => void;
};

export default function ProfileUpload({ onChange }: Props) {
  const { userData: user } = useContext(AuthContext);

  const { refetch: uploadPicture, isLoading } = useAPI({
    url: '/upload/image',
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    isFormData: true, // important to tell the hook we're uploading FormData
    onSuccess: responseData => {
      if (responseData?.result) {
        onChange(responseData?.result);
        // responseData?.result
      }
    },
    onError: error => {
      toast.error(error?.response?.data?.message || 'An error occurred');
    },
  });

  const userProfile = useMemo(() => {
    return user?.image;
  }, [user]);

  const handleProfileChange = () => {
    const fileInput = document.createElement('input') as HTMLInputElement;
    fileInput.type = 'file';
    fileInput.accept = '.jpg, .jpeg, .png';
    fileInput.onchange = e => {
      const target = e.target as HTMLInputElement;
      const file = target.files?.[0];
      if (file) {
        const formData = new FormData();
        formData.append('image', file);
        uploadPicture(formData);
      }
    };
    fileInput.click();
  };

  const handleDelete = () => onChange();

  return (
    <div className="d-flex gap-5 align-items-center bg-primary-50 p-3 rounded">
      <div
        className="rounded-circle bg-white"
        style={{ height: 118, aspectRatio: '1/1' }}
      >
        {userProfile ? (
          <img className={'rounded-circle ' + styles.image} src={userProfile} />
        ) : (
          <div className="h-100 w-100 d-flex justify-content-center align-items-center">
            <UserIcon size={70} color="var(--primary-50)" />
          </div>
        )}
      </div>
      <Button className="bg-black fw-bold" onClick={handleProfileChange}>
        Change Profile Picture
      </Button>
      <Button
        onClick={handleDelete}
        className="text-primary fw-bold"
        variant="plain"
      >
        Delete
      </Button>
    </div>
  );
}
